import React, { useState } from 'react'
import Applied from './applied'
import Suggested from './suggested'

const Index = () => {
    const [activeTab, setActiveTab] = useState("Applied Jobs");

    return (
        <React.Fragment>
            {activeTab === 'Applied Jobs' ? <Applied
                setActiveTab={setActiveTab}
                activeTab={activeTab}
            /> : < Suggested
                setActiveTab={setActiveTab}
                activeTab={activeTab}
            />}
        </React.Fragment>
    )
}

export default Index